// extracted by mini-css-extract-plugin
export default {"content":"content-aeQi3","subMenu":"subMenu-kd4jG","assignmentsListLayout":"assignmentsListLayout-zfoRu"};